const { SET_NTH_CATEGORY } = require('../../constants/actionTypes/nthCategory');


const initialState = {};

const reducer = function (state = initialState, action) {
    const {
        type, payload
    } = action;

    switch (type) {
        case SET_NTH_CATEGORY: {
            const {
                data, requestOptions, displayOptions
            } = payload;

            return {
                ...initialState,
                ...data,
                requestOptions,
                displayOptions
            };
        }
        default: {
            return state;
        }
    }
};

module.exports = reducer;
